import { type AppErrorCode, isAppErrorData } from "@repo/shared";
import { ConvexError } from "convex/values";

const GENERIC_MESSAGE = "Something went wrong. The team has been notified.";

const ERROR_COPY: Partial<Record<AppErrorCode, string>> = {
  STALE_VERSION: "Someone else updated this item. Refresh to see the latest version.",
  RATE_LIMITED: "You're doing that too fast. Wait a moment and try again.",
  UPSTREAM_UNAVAILABLE: "Couldn't reach WorkOS — nothing was changed. Retry.",
  LAST_ADMIN: "An organization must keep at least one admin.",
  INTERNAL_ERROR: GENERIC_MESSAGE,
};

export function getErrorMessage(error: unknown, fallback: string = GENERIC_MESSAGE): string {
  if (error instanceof ConvexError && isAppErrorData(error.data)) {
    return ERROR_COPY[error.data.code] ?? error.data.message;
  }
  return fallback;
}
